class BannerVideoSlideshow {
  constructor(container) {
    this.container = container;
    this.slides = Array.from(container.querySelectorAll('.banner__video-slide'));
    this.currentIndex = 0;
    this.isLooping = container.dataset.loop === 'true';
    this.hideControls = container.dataset.hideControls === 'true';
    this.timeouts = [];
    this.isTransitioning = false;

    if (this.slides.length > 1) {
      this.init();
    }
  }

  init() {
    // Start first video
    this.playVideo(this.slides[0]);
    this.scheduleNextSlide();

    // Hide controls if setting is enabled
    if (this.hideControls) {
      const controls = this.container.querySelector('.slider-buttons');
      if (controls) {
        controls.style.display = 'none';
      }
    }
  }

  playVideo(slide) {
    const video = slide.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.play();
    }
  }

  stopVideo(slide) {
    const video = slide.querySelector('video');
    if (video) {
      video.pause();
    }
  }

  scheduleNextSlide() {
    const currentSlide = this.slides[this.currentIndex];
    const duration = parseInt(currentSlide.dataset.duration, 10) * 1000;

    this.timeouts.push(setTimeout(() => {
      if (!this.isTransitioning) {
        this.nextSlide();
      }
    }, duration));
  }

  updateCounter() {
    const counter = this.container.querySelector('.slider-counter--current');
    if (counter) {
      counter.textContent = this.currentIndex + 1;
    }
  }

  async nextSlide() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    const currentSlide = this.slides[this.currentIndex];
    let nextIndex = this.currentIndex + 1;

    // Handle looping
    if (nextIndex >= this.slides.length) {
      if (!this.isLooping) {
        this.isTransitioning = false;
        return;
      }
      nextIndex = 0;
    }

    // Stop current video
    this.stopVideo(currentSlide);

    // Prepare next slide
    const nextSlide = this.slides[nextIndex];
    nextSlide.style.transform = 'translateX(100%)';
    nextSlide.style.visibility = 'visible';
    nextSlide.style.opacity = '1';

    // Animate slides with smooth transition
    await Promise.all([
      currentSlide.animate([
        { transform: 'translateX(0)', opacity: 1 },
        { transform: 'translateX(-100%)', opacity: 0 }
      ], {
        duration: 800,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        fill: 'forwards'
      }).finished,
      nextSlide.animate([
        { transform: 'translateX(100%)', opacity: 0 },
        { transform: 'translateX(0)', opacity: 1 }
      ], {
        duration: 800,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        fill: 'forwards'
      }).finished
    ]);

    currentSlide.style.visibility = 'hidden';
    nextSlide.classList.add('active');
    currentSlide.classList.remove('active');

    // Activate next slide
    this.playVideo(nextSlide);
    this.currentIndex = nextIndex;
    this.scheduleNextSlide();
    this.isTransitioning = false;
  }

  destroy() {
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    this.timeouts = [];
    this.slides.forEach(slide => this.stopVideo(slide));
  }
}

// Initialize all video slideshows
document.addEventListener('DOMContentLoaded', () => {
  const slideshows = document.querySelectorAll('.banner__video-container');
  slideshows.forEach(container => {
    new BannerVideoSlideshow(container);
  });
});

// Re-initialize on section load if using Shopify section rendering
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.banner__video-container');
    if (container) {
      new BannerVideoSlideshow(container);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const container = event.target.querySelector('.banner__video-container');
    if (container && container.videoSlideshow) {
      container.videoSlideshow.destroy();
    }
  });
}
